import React from "react";

export const Install = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function Install(props, ref) {
	return (
		<svg ref={ref} fill="currentColor" {...props}>
			<use xlinkHref="#icon-install"></use>
		</svg>
	);
});
